// extracted by mini-css-extract-plugin
export default {"wrap":"Logo_wrap__Fr1zg","float":"Logo_float__3UiSa","img":"Logo_img__LdRhM","halo":"Logo_halo__jJvcx","pulse":"Logo_pulse__L8xkS"};